import { put, call, takeEvery } from 'redux-saga/effects';
import ActionTypes from '../constants/ActionTypes';
import { getJupyterPodStatus, createJupyterPod } from '../api/test';

import { errorLogger } from '../utils/trackingUtil';

function* getJupyterResourceStatus(args) {
  try {
    const url = `/get_servers/djp/${args.testSolutionId}`;
    const resp = yield call(getJupyterPodStatus, url);
    yield put({
      type: `${ActionTypes.CHECK_ENV_SETUP_STATUS}_SUCCESS`,
      payload: resp.data,
    });
  } catch (err) {
    errorLogger(err);
  }
}

function* checkAndCreateJupyterResource(args) {
  try {
    const url = `/create_servers/djp/${args.testSolutionId}`;
    yield call(createJupyterPod, url);

    yield put({
      type: ActionTypes.IS_POD_BASED_PROBLEM,
      payload: true,
    });
    yield put({
      type: `${ActionTypes.CHECK_ENV_SETUP_STATUS}_SUCCESS`,
      payload: { isReady: false },
    });
  } catch (err) {
    if (
      err.response.status === 400 &&
      err.response.message === 'Test does not have any DJP questions'
    )
      yield put({
        type: ActionTypes.IS_POD_BASED_PROBLEM,
        payload: false,
      });
    else {
      yield put({
        type: `${ActionTypes.CHECK_ENV_SETUP_STATUS}_SUCCESS`,
        payload: { isReady: null },
      });
    }
  }
}

export default function* datascienceJupyterSaga() {
  yield takeEvery(ActionTypes.CHECK_ENV_SETUP_STATUS, getJupyterResourceStatus);
  yield takeEvery(
    ActionTypes.CHECK_DJP_PROBLEM_IN_TEST_AND_SETUP,
    checkAndCreateJupyterResource
  );
}
